export default "__VITE_ASSET__CvNWAAQJ__"